import moment from "moment";
import { formatDate } from "../../core/utils/date-handlers";
import { getDateFormattedAsMoment } from "../../core/utils/dates";
import { dateTypes } from "../../typescript/dates/date-models";

export const isValidDate = (value) => {
    let date = moment(value);
    return date.isValid()
}

export function formattedDate(value, addSeconds?) {
    if (!isValidDate(value)) {
        return '-';
    } 
    if(addSeconds){
        return formatDate(value, addSeconds);
    }else{
        return formatDate(value);
    }   
}

export const formatCommaSeparatedStringList = (list: string[] ):string | null => {
    if(Array.isArray(list) ){
        return list.join(', ')
    }
    return null
};
export const formatComplexList = (list: Array<object>, kei: string ) => {
    return formatCommaSeparatedStringList(list.map(function(item){
        return item[kei]
    }))
};
export function formatList(list: string[], kei?) {
    if (kei) {
        list = list.map(function(item) {
            return item[kei];
        });
    }
    return list.join(', ');
}

export const booleanFormatter = value => {
    return value ? 'Si' : 'No';
};

export const activeFormatter = value => {
    if(value === undefined || value === null){
        return '-';
    }
    return value ? 'Activa' : 'Inactiva';
};


export const nullFormatter = value => {
    return value == null ? '-' : value;
};

export const nullFormatterGetZero = value => {
    return value == null ? 0 : value;
};

export const nullOrEmptyFormatter = value => {
    if (value == null || value === '') {
        return '-';
    }
    return value;
}

export const getOnlyDateFromTimestamp = (value) =>{
    return getDateFormattedAsMoment(value, dateTypes.dateYearFormatBars, dateTypes.globalFilterDateFormat)
}
